// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialogForm .el-input[data-v-4ac563f9] {\n  width: 240px;\n}", ""]);
// Exports
module.exports = exports;
